import client from "../Client/HttpClient";
import {IIdentitiesModel} from "@/interfaces/modules";
const ApiPath = "Identities";

export default {
    GetIdentities:(): Promise <IIdentitiesModel[]> => client.get(`${ApiPath}`),
    GetIdentitiesById: (data: IIdentitiesModel ):Promise<IIdentitiesModel>=>client.get(`${ApiPath}/${data.Id}`),
    PostIdentities : (data:IIdentitiesModel ) : Promise<IIdentitiesModel>=>client.post(`${ApiPath}`, data),
  };